"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTourBoardLatestData = exports["default"] = void 0;

var _reselect = require("reselect");

var _widgets = require("../widgets/widgets.actions");

var _latestDataNeo = require("./latest-data-neo.actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _widgets.ADD_WIDGET_SUCCESS:
      {
        var widget = action.body.widget;

        if (widget.type === 26) {
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, widget.id, {}));
        }

        return state;
      }

    case _latestDataNeo.FIND_LATESTDATA_SUCCESS:
      {
        var widgetId = action.headers.widgetId;
        var latestData = action.body.latestData;
        var newAssets = latestData.reduce(function (result, asset) {
          return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, asset.id, _objectSpread({}, asset)));
        }, {});

        if (state[widgetId]) {
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, widgetId, _objectSpread(_objectSpread({}, state[widgetId]), newAssets)));
        }

        return state;
      }

    default:
      return state;
  }
};

exports["default"] = _default;

var getTourBoardLatestData = function getTourBoardLatestData(_ref) {
  var widgetId = _ref.widgetId;
  return (0, _reselect.createSelector)(function (state) {
    return state.tourboard[widgetId];
  }, function (data) {
    return data !== null && data !== void 0 ? data : {};
  });
};

exports.getTourBoardLatestData = getTourBoardLatestData;